module.exports = __webpack_public_path__ + "img/Lego.01bd8628.jpg";